export default "__VITE_ASSET__DKK9BOiQ__"